import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'

import { useInitData } from '../../../hooks'
import {
  FilesPreviewGallery,
  useFilePreviewGallery,
} from '../../FilesPreviewGallery'
import {
  getTableRowQaProps,
  TableCellFreeSpaceFiller,
  TableRowActions,
  TableRowContextActions,
  useTableRowActions,
  useTableRowModClassName,
} from '../../Table'
import { toMultiListFiles, toPreviewFiles } from '../DocFlow.utils.files'
import { DocFlowResultTableCellName } from '../DocFlowResult'

import { ROW_ACTIONS_CONFIG } from './DocFlowResultTableRow.constants'
import { renderCell } from './DocFlowResultTableRow.utils'

import * as styles from './DocFlowResultTableRow.module.css'

function DocFlowResultTableRow({
  Actions = TableRowActions,
  actionLeft,
  actionsColumnWidth,
  columns,
  emptyColumnSize,
  focusedRow,
  getActions,
  hideCheckbox,
  isLoading,
  isResizing,
  isSelected,
  isShort,
  item,
  permissions,
  phaseDisabled,
  resizingColumn,
  scrollRef,
  showCellBorder,
  onEpostResend,
  ...restProps
}) {
  const { t } = useTranslation()

  const { availableSections } = useInitData()

  const {
    handleCallAction,
    handleClick,
    handleMouseEnter,
    handleMouseLeave,
    handleSelect,
  } = useTableRowActions({ item, ...restProps }, ROW_ACTIONS_CONFIG)

  const previewFiles = toPreviewFiles(item[DocFlowResultTableCellName.File])

  const { activeFileIndex, handleClickFile, handleCloseFilePreview } =
    useFilePreviewGallery({
      files: previewFiles,
    })

  const preparedFiles = toMultiListFiles(
    item[DocFlowResultTableCellName.File],
    t
  )

  const className = useTableRowModClassName({
    className: styles.DocFlowResultTableRow,
    isSelected,
  })

  const qaProps = getTableRowQaProps()

  function handleEpostResend() {
    onEpostResend(item.id)
  }

  return (
    <>
      <div
        {...qaProps}
        className={className}
        onClick={handleClick}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {Actions ? (
          <Actions
            disabled={phaseDisabled || hideCheckbox || item.uploading}
            selected={isSelected}
            width={actionsColumnWidth}
            onChange={handleSelect}
          />
        ) : null}
        {columns.map(column => (
          <Fragment key={column.name}>
            {renderCell({
              availableSections,
              canResendEpost:
                !permissions.is_outdated_cost && item.can_resend_epost,
              disabledResendPost: !permissions.is_positive_balance,
              isActive: column.name === resizingColumn,
              isLoading,
              isResizing,
              isShort,
              item,
              name: column.name,
              preparedFiles,
              scrollRef,
              showCellBorder,
              t,
              width: column.width,
              onClickFile: handleClickFile,
              onEpostResend: handleEpostResend,
            })}
          </Fragment>
        ))}
        <TableCellFreeSpaceFiller width={emptyColumnSize} />
        {getActions?.(item).length > 0 && !phaseDisabled ? (
          <TableRowContextActions
            actionLeft={actionLeft}
            focusedRow={focusedRow}
            getActions={getActions}
            item={item}
            onCallAction={handleCallAction}
          />
        ) : null}
      </div>
      <FilesPreviewGallery
        files={previewFiles}
        initActive={activeFileIndex}
        onClose={handleCloseFilePreview}
      />
    </>
  )
}

export default DocFlowResultTableRow
